import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import { PrivateRoute } from './PrivateRoute';

import { LoginRoutes } from './login';
import { DocumentRoutes } from './document';
import { Main } from 'pages/Main';
import { ControlTower } from 'pages/ControlTower';
import { SettingsRoutes } from './settings';
import { GlobalAnalyse } from 'pages/GlobalAnalyse';
import { AnalyseByRegion } from 'pages/AnalyseByRegion';
import { AnalyseByClient } from 'pages/AnalyseByClient';

const ExternalCronogramaRedirect: React.FC = () => {
  useEffect(() => {
    window.location.replace(
      'https://app.smartsheet.com/sheets/vfvrm9w2QXjcmRCjvpMVJ66Jw4pm72GVVh8Q6GM1?view=grid',
    );
  }, []);
  return null;
};

export const Routes: React.FC = () => {
  return (
    <>
      <Switch>
        <PrivateRoute path="/" exact component={Main} />
        <PrivateRoute path="/base/base" exact component={Main} />
        <PrivateRoute path="/control-tower" exact component={ControlTower} />
        <PrivateRoute
          path="/control-tower/global-analyse"
          exact
          component={GlobalAnalyse}
        />
        <PrivateRoute
          path="/control-tower/analyse-by-region"
          exact
          component={AnalyseByRegion}
        />
        <PrivateRoute
          path="/control-tower/analyse-by-client"
          exact
          component={AnalyseByClient}
        />

        {/* Public route for /cronograma */}
        <Route
          path="/cronograma"
          exact
          component={ExternalCronogramaRedirect}
        />
      </Switch>
      <LoginRoutes />
      <SettingsRoutes />
      <DocumentRoutes />
    </>
  );
};
